import { AuditLog } from '@/types/audit';
import { format } from 'date-fns';
import { ptBR } from 'date-fns/locale';
import { getActionLabel, getEntityTypeLabel } from './action-labels';

export async function exportAuditToCSV(logs: AuditLog[], filename?: string) {
  const headers = [
    'Data/Hora',
    'Usuário',
    'Ação',
    'Tipo de Entidade',
    'ID da Entidade',
    'Empresa',
    'Valores Anteriores',
    'Novos Valores',
    'Metadados'
  ];

  const rows = logs.map(log => [
    format(new Date(log.created_at), 'dd/MM/yyyy HH:mm:ss', { locale: ptBR }),
    log.actor_user_id || '-',
    getActionLabel(log.action),
    getEntityTypeLabel(log.entity_type),
    log.entity_id || '-',
    log.company_id || '-',
    log.old_values ? JSON.stringify(log.old_values) : '-',
    log.new_values ? JSON.stringify(log.new_values) : '-',
    log.meta ? JSON.stringify(log.meta) : '-',
  ]);

  const csvContent = [
    headers.join(','),
    ...rows.map(row => row.map(cell => `"${cell}"`).join(','))
  ].join('\n');

  const blob = new Blob(['\uFEFF' + csvContent], { type: 'text/csv;charset=utf-8;' });
  const link = document.createElement('a');
  const url = URL.createObjectURL(blob);
  
  link.setAttribute('href', url);
  link.setAttribute('download', filename || `auditoria_${format(new Date(), 'yyyyMMdd_HHmmss')}.csv`);
  link.style.visibility = 'hidden';
  
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
}

export async function exportAuditToExcel(logs: AuditLog[], filename?: string) {
  // Import dynamically to avoid bundling if not used
  const XLSX = await import('xlsx');
  
  const worksheet = XLSX.utils.json_to_sheet(
    logs.map(log => ({
      'Data/Hora': format(new Date(log.created_at), 'dd/MM/yyyy HH:mm:ss', { locale: ptBR }),
      'Usuário': log.actor_user_id || '-',
      'Ação': getActionLabel(log.action),
      'Tipo': getEntityTypeLabel(log.entity_type),
      'ID Entidade': log.entity_id || '-',
      'Empresa': log.company_id || '-',
      'Valores Anteriores': log.old_values ? JSON.stringify(log.old_values) : '-',
      'Novos Valores': log.new_values ? JSON.stringify(log.new_values) : '-',
      'Metadados': log.meta ? JSON.stringify(log.meta) : '-',
    }))
  );

  const workbook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(workbook, worksheet, 'Auditoria');

  XLSX.writeFile(workbook, filename || `auditoria_${format(new Date(), 'yyyyMMdd_HHmmss')}.xlsx`);
}
